
$( document ).ready( function()
{
  var enable_autoplay = $(".pass-content").attr("data-enable_autoplay");
  var auto_slideshow_speed = $(".pass-content").attr("data-auto_slideshow_speed");
  
    $( '.pass-content' ).slick
    ({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: enable_autoplay == 'false'?false:true,
        autoplaySpeed: auto_slideshow_speed,
        responsive: 
        [
          {
            breakpoint: 768,
            settings: 
            {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="37" height="25" viewBox="0 0 37 25" fill="none"><path d="M2.26407 14.1249L15.6447 23.7278C16.968 24.6774 18.8108 23.7317 18.8108 22.1029V17.4634C18.8108 16.3588 19.7062 15.4634 20.8108 15.4634L34 15.4634C35.1046 15.4634 36 14.568 36 13.4634V11.5366C36 10.432 35.1046 9.53658 34 9.53658L20.8108 9.53658C19.7062 9.53658 18.8108 8.64116 18.8108 7.53658V2.89709C18.8108 1.2683 16.968 0.322554 15.6447 1.27224L2.26407 10.8751C1.15223 11.6731 1.15223 13.3269 2.26407 14.1249Z" fill="#CEEBEE" stroke="black"/></svg></button>',
              nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="37" height="25" viewBox="0 0 37 25" fill="none"><path d="M34.7359 10.8751L21.3553 1.27224C20.032 0.322553 18.1892 1.2683 18.1892 2.89709V7.53659C18.1892 8.64116 17.2938 9.53659 16.1892 9.53659H3C1.89543 9.53659 1 10.432 1 11.5366V13.4634C1 14.568 1.89543 15.4634 3 15.4634H16.1892C17.2938 15.4634 18.1892 16.3588 18.1892 17.4634V22.1029C18.1892 23.7317 20.032 24.6774 21.3553 23.7278L34.7359 14.1249C35.8478 13.3269 35.8478 11.6731 34.7359 10.8751Z" fill="#0EC4B9" stroke="black"/></svg></button>'
            }
          },
        ]
    });
});

  
      